// portal Bumeran and ZonaJobs

import { parseDate } from '@components/utilities/date';
import { getYear, getMonth, parse, isValid } from 'date-fns';
import { groupBy, find, trim } from 'lodash';
import { ALLOWED_STATUSES } from '@/postulation_form/components/attached-files/constants';
import { _gender, _language, _timeAvailability } from '../../constant/vacancy';
import { typesPhone, bumeranCv } from './constants';

const mapeducations = (data = []) => {
  const educations = data.map((d) => {
    const fechaInicio = parse(d.fechaInicio, 'dd-MM-yyyy', new Date());
    const fechaFin = parse(d.fechaFin, 'dd-MM-yyyy', new Date());
    const { institucionEducativa = {} } = d;
    const actualEducation = d.estadoEstudio?.id === bumeranCv.education.status.inCourse;

    return {
      degree: d.titulo,
      locality: d.pais?.id,
      intitution: institucionEducativa.id !== null ? institucionEducativa.id : institucionEducativa.nombre,
      from_month: isValid(fechaInicio) ? getMonth(fechaInicio) : null,
      from_year: isValid(fechaInicio) ? getYear(fechaInicio) : null,
      to_month: isValid(fechaFin) ? getMonth(fechaFin) : null,
      to_year: !actualEducation && isValid(fechaFin) ? getYear(fechaFin) : null,
      descript: d.descripcion,
      study_level: d.tipoEstudio?.id,
      study_status: d.estadoEstudio?.id,
      area_education: d.areaEstudio?.id,
      actual_education: actualEducation
    };
  });
  return educations;
};

function mapLanguages(data) {
  const mapeado = [];
  const Languages = data.filter((conocimiento) => conocimiento.tipo === 'Idiomas');

  Languages.forEach((element) => {
    let nombreIdioma;

    _language.forEach((language) => {
      if (language.label === element.nombre) {
        nombreIdioma = language.value;
      }
    });

    const indice = mapeado.findIndex((x) => x.language === nombreIdioma);
    const existente = mapeado[indice];

    const nivelIdioma = {
      language: nombreIdioma,
      oralLevel: existente?.oralLevel || null,
      writtenLevel: existente?.writtenLevel || null
    };

    if (element.calificador == '17') {
      nivelIdioma.oralLevel = element.nivel;
    }

    if (element.calificador == '16') {
      nivelIdioma.writtenLevel = element.nivel;
    }

    if (existente) {
      mapeado[indice] = nivelIdioma;
    } else {
      mapeado.push(nivelIdioma);
    }
  });

  return mapeado;
}

function formatDate(date) {
  if (date) {
    const day = new Date(date * 1000).getDate().toString();
    const month = new Date(date * 1000).getMonth();
    const year = new Date(date * 1000).getFullYear().toString();
    if (month < 9) {
      return `${day}-0${month + 1}-${year}`;
    }
    return `${day}-${month + 1}-${year}`;
  }
  return null;
}

function genderMatch(gender) {
  const genderlowerCase = gender?.toLowerCase();
  const gen =
    genderlowerCase === 'otro' || genderlowerCase === 'other'
      ? gender
      : _gender.find((g) => {
          if (g.value !== null) {
            return g.value.toLowerCase() === genderlowerCase || g.label.toLowerCase() === genderlowerCase;
          }
          return g.value === gender;
        })?.value || 'other';

  return gen;
}

const mapPostNavent = (items) => {
  const data = items.map((i) => {
    const dateFrom = parseDate(i.fechaInicio);
    const dateTO = parseDate(i.fechaFin);

    return {
      job: i.puesto,
      seniority: i.nivelPuesto?.id,
      company: i.empresa,
      locality: i.pais?.id,
      from_month: dateFrom?.getMonth(),
      from_year: dateFrom?.getFullYear(),
      to_month: dateTO?.getMonth(),
      to_year: dateTO?.getFullYear(),
      area: i.area?.id,
      subarea: i.subArea?.id,
      industry: i.industria?.id,
      descript: i.detalle,
      actual_job: i.fechaFin === null
    };
  });
  return data;
};

const mapLanguagesNavent = (idiomas = []) => {
  const groupName = groupBy(idiomas, 'tipo.nombre');
  const data = [];
  Object.keys(groupName).forEach((i) => {
    const writtenLevel = find(groupName[i], (d) => {
      return d.calificador.nombre === 'Escrito';
    });
    const oralLevel = find(groupName[i], (d) => {
      return d.calificador.nombre === 'Oral';
    });
    data.push({
      language: find(_language, { label: i })?.value,
      writtenLevel: writtenLevel?.nivel.id,
      oralLevel: oralLevel?.nivel.id,
      descripcion: ''
    });
  });
  return data;
};

const mapNormalizedKnowledges = (knowledges = []) => {
  const resultKnowledges = [];

  knowledges.forEach((knowledge) => {
    const knowledgeObject = {};

    if (!knowledge.id) {
      return;
    }
    knowledgeObject.id_detalle = knowledge.id;

    if (!knowledge.grupo?.nombre || ['Idiomas', 'Personalizado'].includes(knowledge.grupo?.nombre)) {
      return;
    }
    knowledgeObject.tipo = knowledge.grupo.nombre;

    if (!knowledge.tipo?.nombre) {
      return;
    }
    knowledgeObject.nombre = knowledge.tipo.nombre;

    if (!knowledge.nivel?.id) {
      return;
    }
    knowledgeObject.nivel = knowledge.nivel.id;

    if (!knowledge.conocimientoEspecifico?.nombre || !knowledge.calificador?.nombre || !knowledge.nivel?.nombre) {
      return;
    }

    knowledgeObject.descripcion = `${knowledge.conocimientoEspecifico.nombre}. ${knowledge.calificador.nombre} Nivel: ${knowledge.nivel.nombre}`;

    resultKnowledges.push(knowledgeObject);
  });

  return resultKnowledges;
};

const mapDocumentType = (type) => {
  if (type === 25 || type === 45) return 'dni';
  if (type === 27) return 'passport';
  // if (type === 26) return 'L.E.'; // Dejo comentadas estas opciones por si en un futuro las agregamos
  // if (type === 28) return 'L.C.';

  return null;
};

export const formatEducationList = (educationsList, process) => {
  educationsList.forEach((educationItem) => {
    const valuesToEval = {
      from_month: educationItem.from_month ?? null,
      to_month: educationItem.to_month ?? null
    };

    Object.keys(valuesToEval).forEach((key) => {
      const fieldValue = educationItem[key] ?? null;

      if (fieldValue !== null && !Number.isNaN(educationItem[key])) {
        if (process === 'new') {
          educationItem[key] += 1;
        } else {
          educationItem[key] = educationItem[key] > 0 ? educationItem[key] - 1 : 0;
        }
      }
    });
  });

  return educationsList;
};

export const formatJobsList = (jobsList, process) => {
  jobsList.forEach((jobItem) => {
    const valuesToEval = {
      from_month: jobItem.from_month ?? null,
      to_month: jobItem.to_month ?? null
    };

    Object.keys(valuesToEval).forEach((key) => {
      const fieldValue = jobItem[key] ?? null;

      if (fieldValue !== null && !Number.isNaN(jobItem[key])) {
        if (process === 'new') {
          jobItem[key] += 1;
        } else {
          jobItem[key] = jobItem[key] > 0 ? jobItem[key] - 1 : 0;
        }
      }
    });
  });

  return jobsList;
};

export const mapPostulantApiNavent = (data, action = 'create', requirements) => {
  const conocimientoNormalizados = groupBy(data.cv?.conocimientosNormalizados, 'grupo.nombre');
  const dni = trim(data?.numeroDocumento);
  const cv = data.cv || {};
  const direccion = data?.direccion;

  const postulant = {
    ...(requirements.address && { permanent_address: direccion }), // TODO:revisar domicilio actual
    ...(requirements.born && { born: data?.fechaNacimiento }),
    ...(requirements.dni && { dni }),
    ...(requirements.dni && { doc_num: dni }),
    ...(requirements.dni && { type_doc: mapDocumentType(data?.tipoDocumento?.id) }),
    ...(requirements.educ && { educations: mapeducations(cv?.estudios || []) }),
    ...(requirements.firstname && { firstname: data?.nombre }),
    ...(requirements.gender && { gender: genderMatch(data.genero) }),
    ...(requirements.handicapped && {
      discapacidad: { status: !!data.discapacidad, detalle: data.discapacidad }
    }),
    ...(requirements.jobs && { posts: mapPostNavent(cv?.experienciasLaborales || []) }),
    ...(requirements.language && {
      languages: mapLanguagesNavent(conocimientoNormalizados.Idiomas)
    }),
    ...(requirements.lastname && { lastname: data?.apellido }),
    ...(requirements.locality && { locality: direccion }),
    ...(requirements.locality && {
      location: {
        country: data?.paisResidencia?.id,
        province: null, // obtenemos los valores de la direccion
        city: null
      }
    }),
    ...(requirements.mail && { email: data?.email }),
    ...(requirements.mail && { emailConfirm: data?.email }),
    ...(requirements.nationality && { nationality: data.paisNacimiento?.id }),
    ...(requirements.phone && { phone: data.telefonoCelular?.numero }),
    ...(requirements.phone && { prefix_phone_1: data.telefonoCelular?.prefijo }),
    ...(requirements.phone && {
      type_phone_1: data.telefonoCelular.numero ? typesPhone[0].label : null
    }),
    ...(requirements.phone2 && { phone_2: data.telefonoFijo?.numero }),
    ...(requirements.phone2 && { prefix_phone_2: data.telefonoFijo?.prefijo }),
    ...(requirements.phone2 && {
      type_phone_2: data.telefonoFijo.prefijo ? typesPhone[0].label : typesPhone[1].label
    }),
    ...(requirements.remuneration && { desiredSalary: cv?.salarioPreferencia }),
    ...(requirements.url_perfil && { fotoURL: data?.fotoURL }),
    ...(requirements.url_perfil && { bum_img_profile: data?.fotoURL }),
    id_cv_from_bum: cv?.id,
    conocimientosNormalizados: mapNormalizedKnowledges(cv?.conocimientosNormalizados || []),
    conocimientosDesnormalizados: cv?.conocimientosDesnormalizados,
    referencias: cv?.referencias
  };

  // * Para la edición de datos importando un cv se omite modificar el mail que ya existe
  if (action === 'edit') {
    delete postulant.email;
  }
  return postulant;
};

export const mapPostulantEdit = (data) => {
  const isHighSchoolComplete = data.tags?.find((va) => {
    return va.name === 'Secundaria completa';
  })
    ? 'si'
    : 'no';

  const educationsList = data.educations ?? [];
  const jobsList = data.posts ?? [];

  const knowledges = data.conocimientos || [];
  const normalizedKnowledges = knowledges.filter(
    (knowledge) => knowledge.tipo !== 'Idiomas' && knowledge.tipo !== 'Personalizado'
  );
  const unnormalizedKnowledges = knowledges.filter((knowledge) => knowledge.tipo === 'Personalizado');

  const postulant = {
    firstname: data?.firstname,
    lastname: data.lastname === 'Sin especificar' ? null : data.lastname,
    email: data?.email,
    dni: data?.dni,
    doc_num: data?.doc_num,
    type_doc: data?.type_doc,
    prefix_phone_1: data?.prefix_phone_1,
    phone: data?.phone,
    type_phone_1: data?.type_phone_1,
    prefix_phone_2: data?.prefix_phone_2,
    phone_2: data?.phone_2,
    type_phone_2: data?.type_phone_2,
    gender: genderMatch(data.gender),
    legacy: data.legacy,
    nationality: data?.nationality, // hacer match el nombre con el ID en los countries
    location: data?.location, // objeto con los ID de la ciudad, provincia y pais
    locality: data?.locality, // String con el nombre de la ciudad, provincia y pais
    ubication: data?.ubication, // String con el nombre de la ciudad, provincia y pais (Este no lo usamos creo pero lo dejo para mas adelante discutirlo)
    permanent_address: data?.permanent_address,
    born: formatDate(data.born),
    discapacidad: data?.discapacidad,
    educations: formatEducationList(educationsList, 'edit') || [],
    languages: mapLanguages(data.conocimientos || []),
    posts: formatJobsList(jobsList, 'edit'),
    url_linkedin: data?.url_linkedin,
    url_facebook: data?.url_facebook,
    url_twitter: data?.url_twitter,
    url_website: data?.url_website,
    relocation: data?.relocation?.toString() || null,
    desiredSalary: data?.desiredSalaryNumber,
    high_school_data: isHighSchoolComplete,
    available_time:
      _timeAvailability.find((time) => {
        return time.label === data.available_time;
      })?.value || null,
    additional_message: data.additional_message,
    termsConditions: {
      hiring: data?.termsConditions?.hiring,
      bumeran: data?.termsConditions?.bumeran
    },
    known: {
      relationCompany: data?.mod_known?.known,
      name: data?.mod_known?.name,
      relation: data?.mod_known?.rel
    },
    fotoURL: data.profile_image ? data.profile_image : null,
    conocimientosNormalizados: normalizedKnowledges,
    conocimientosDesnormalizados: unnormalizedKnowledges,
    showQuestions: data.showQuestions
  };

  return postulant;
};

export const getPostulantSource = (source, urlSegment = '') => {
  if (urlSegment === 'internal_jobs') {
    // Portal interno
    return 'internal';
  }

  if (typeof source === 'undefined' || !source) {
    // Micrositios y portal externo
    return 'Web';
  }

  if (source === 'referral') {
    // Panel de referentes
    return 'referral';
  }

  // TODO: Validar a partir de una lista válida de sources que la que se va a utilizar corresponda a una válida
  return source;
};

export function isFormSubmitPending(params) {
  const { isPendingRequest, isPendingForm, isPendingReCaptchaGeneration, isActionBlockingSubmit } = params;

  return isPendingRequest || isPendingForm || isPendingReCaptchaGeneration || isActionBlockingSubmit;
}

const extractPhoneData = (fullPhone) => {
  if (!fullPhone || typeof fullPhone !== 'string') {
    return { prefix: '54', number: '' };
  }

  // Limpiar el string: eliminar espacios, paréntesis, guiones, puntos
  const cleaned = fullPhone.replace(/[\s\(\)\-\.]/g, '');

  // Buscar prefijo con + seguido de 1 a 4 dígitos
  const prefixMatch = cleaned.match(/^\+(\d{1,4})/);

  if (prefixMatch) {
    // Caso 1: Prefijo con + explícito
    const prefix = prefixMatch[1];
    const numberWithoutPrefix = cleaned.replace(`+${prefix}`, '');

    return {
      prefix,
      number: numberWithoutPrefix
    };
  }

  // Caso 2: Verificar si empieza con prefijos conocidos sin +
  const knownPrefixes = {
    54: '54', // Argentina
    34: '34', // España
    55: '55', // Brasil
    52: '52', // México
    56: '56', // Chile
    57: '57', // Colombia
    58: '58', // Venezuela
    593: '593', // Ecuador
    51: '51', // Perú
    591: '591', // Bolivia
    595: '595', // Paraguay
    598: '598', // Uruguay
    507: '507', // Panama
    86: '86', // China
    91: '91', // India
    61: '61', // Australia
    27: '27', // Sudáfrica
    31: '31', // Países Bajos
    46: '46', // Suecia
    47: '47', // Noruega
    45: '45', // Dinamarca
    358: '358', // Finlandia
    48: '48', // Polonia
    420: '420', // República Checa
    36: '36', // Hungría
    40: '40', // Rumania
    43: '43', // Austria
    41: '41', // Suiza
    32: '32', // Bélgica
    351: '351', // Portugal
    30: '30', // Grecia
    90: '90', // Turquía
    7: '7', // Rusia
    380: '380', // Ucrania
    375: '375', // Bielorrusia
    371: '371', // Letonia
    372: '372', // Estonia
    370: '370', // Lituania
    385: '385', // Croacia
    386: '386', // Eslovenia
    387: '387', // Bosnia y Herzegovina
    389: '389', // Macedonia del Norte
    381: '381', // Serbia
    382: '382', // Montenegro
    355: '355', // Albania
    359: '359', // Bulgaria
    353: '353', // Irlanda
    354: '354' // Islandia
  };

  // Buscar si empieza con algún prefijo conocido
  for (const [prefix, value] of Object.entries(knownPrefixes)) {
    if (cleaned.startsWith(prefix)) {
      const numberWithoutPrefix = cleaned.substring(prefix.length);
      return {
        prefix: value,
        number: numberWithoutPrefix
      };
    }
  }

  // Caso 3: Si no se detecta prefijo, queda el default de la cuenta
  return {
    number: cleaned
  };
};

const parseDateToBornObj = (dateStr) => {
  if (!dateStr || !/^\d{2}\/\d{2}\/\d{4}$/.test(dateStr)) {
    return { day: null, month: null, year: null };
  }
  const [day, month, year] = dateStr.split('/').map(Number);
  return { day, month, year };
};

/**
 * The `parseDateCvParser` function parses a date string in the format "MM/YYYY" or "MM-YYYY" and
 * returns an object with the month and year values if they are valid.
 * @param dateStr - The `parseDateCvParser` function is designed to parse a date string in the format
 * "MM/YYYY" or "MM-YYYY" and return an object with the extracted month and year values. If the input
 * date string is not in the expected format or if the month or year values are
 * @returns The `parseDateCvParser` function returns an object with `month` and `year` properties. If
 * the input `dateStr` is not a valid string in the format "MM/YYYY" or "MM-YYYY", or if the month is
 * not between 1-12 or the year is not between 1900 and the current year + 10, then it returns an
 * object
 */
const parseDateCvParser = (dateStr) => {
  if (!dateStr || typeof dateStr !== 'string') {
    return { month: null, year: null };
  }

  // Format esperado: "MM/YYYY" o "MM-YYYY"
  const match = dateStr.match(/^(\d{1,2})[\/\-](\d{4})$/);
  if (!match) {
    return { month: null, year: null };
  }

  const month = parseInt(match[1], 10);
  const year = parseInt(match[2], 10);

  // Validar que el mes esté entre 1-12 y el año sea razonable
  if (month < 1 || month > 12 || year < 1900 || year > new Date().getFullYear() + 10) {
    return { month: null, year: null };
  }

  return { month, year };
};

const mapEducations = (eds) =>
  eds?.map((e) => {
    const fromDate = parseDateCvParser(e.init_date);
    const toDate = parseDateCvParser(e.end_date);

    return {
      degree: e.degree || '',
      locality: e.country || '',
      intitution: e.institution || '',
      area_education: null,
      study_level: null,
      study_status: e.study_status || null,
      from_month: fromDate.month,
      from_year: fromDate.year,
      actual_education: e.finished === false || false,
      to_month: toDate.month,
      to_year: toDate.year,
      descript: ''
    };
  }) || [];

export const mapPostulantCvParser = (cv) => {
  const phoneData = extractPhoneData(cv?.contact?.phone);
  const bornObj = parseDateToBornObj(cv?.personalData?.birthdate);

  const languageMap = {
    Español: 'esp',
    Inglés: 'eng',
    Alemán: 'ale',
    Francés: 'fra',
    Italiano: 'ita',
    Portugués: 'por',
    Chino: 'chi',
    Japonés: 'jap',
    Coreano: 'cor',
    Holandés: 'hol',
    Quechua: 'que'
  };

  const mapLanguagesParser = (langs) =>
    langs
      ?.map((l) => {
        const langCode = languageMap[l.name];
        if (!langCode) return null;
        return {
          language: langCode,
          writtenLevel: l.level,
          oralLevel: l.level
        };
      })
      .filter(Boolean) || [];

  const mapPosts = (jobs) => {
    const posts =
      jobs?.map((j) => {
        const fromDate = parseDateCvParser(j.init_date);
        const toDate = parseDateCvParser(j.end_date);

        return {
          job: j.position || '',
          seniority: null,
          company: j.company || '',
          locality: null,
          industry: null,
          area: j.area,
          descript: j.description,
          subarea: null,
          from_month: fromDate.month,
          from_year: fromDate.year,
          actual_job: j.is_current,
          to_month: toDate.month,
          to_year: j.end_date?.toLowerCase?.() === 'actualidad' ? null : toDate.year
        };
      }) || [];
    return posts;
  };
  const getSkills = (skills) => {
    if (Array.isArray(skills)) {
      const listSkills = skills.map((s) => {
        return {
          titulo: s,
          descripcion: s
        };
      });
      return listSkills;
    }

    if (typeof skills === 'object' && skills !== null) {
      const categoryArrays = Object.values(skills);
      const flatSkills = categoryArrays.flat();
      return flatSkills.map((s) => ({
        titulo: s,
        descripcion: s
      }));
    }
    return [];
  };
  return {
    fotoURL: cv?.img_profile || null,
    firstname: cv?.personalData?.firstname || '',
    lastname: cv?.personalData?.lastname || '',
    email: cv?.contact?.email || '',
    emailConfirm: cv?.contact?.email || '',
    type_doc: null,
    dni: '',
    phone: phoneData.number,
    prefix_phone_1: phoneData.prefix || '',
    type_phone_1: null,
    phone_2: phoneData.number,
    prefix_phone_2: phoneData.prefix || '',
    type_phone_2: null,
    gender: genderMatch(cv?.personalData?.genre),
    nationality: cv?.personalData?.nationality || null,
    location: {
      country: null,
      province: null,
      city: null
    },
    permanent_address: cv?.personalData?.direction || '',
    bornObj,
    discapacidad: {
      status: false
    },
    url_linkedin: cv?.contact?.linkedin || '',
    // cv_file: cv?.file_attachment ? { url: cv.file_attachment } : {},
    desiredSalary: '',
    available_time: null,
    known: {
      relationCompany: null,
      relation: null
    },
    termsConditions: {
      bumeran: false,
      hiring: false
    },
    relocation: 'false',
    cv_struct_id: cv.cv_struct_id,
    educations: mapEducations(cv?.education),
    languages: mapLanguagesParser(cv?.languages),
    posts: mapPosts(cv?.experience),
    url_facebook: '',
    url_twitter: '',
    url_skype: '',
    url_website: cv?.contact?.portfolio || cv?.links?.[0] || '',
    additional_message: [cv?.about?.summary, cv?.other].filter(Boolean).join('\n\n'),
    conocimientosDesnormalizados: getSkills(cv?.skills),
    cvFileType: null
  };
};
